import type TranscriptWord from './transcriptWord';

export default class SubtitleCue {
  words: TranscriptWord[] = [];

  private characterLength = 0;
  public addWord(word: TranscriptWord) {
    this.words.push(word);
    this.characterLength += word.content.length;
  }

  public getCharacterLength() {
    /*
      characterLength stores only the sum of all word contents (no spaces).
      When rendered, words are separated by a single space, so the visible length is
      characterLength plus the number of inter-word spaces.
    */
    return this.characterLength + this.words.length - 1;
  }
}
